const DEFAULT_PRODUCTION_API_BASE_URL = 'https://api.divineveg262.co.za';

function cleanApiBaseUrl(value) {
    if (!value || value === '__API_BASE_URL__') {
        return '';
    }

    return value.replace(/\/+$/, '');
}

function getRuntimeApiBaseUrl() {
    if (typeof window === 'undefined') {
        return '';
    }

    return cleanApiBaseUrl(window.__APP_CONFIG__?.API_BASE_URL);
}

const configuredApiBaseUrl = cleanApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
const runtimeApiBaseUrl = getRuntimeApiBaseUrl();
const fallbackApiBaseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:4000'
    : DEFAULT_PRODUCTION_API_BASE_URL;

export const API_BASE_URL = configuredApiBaseUrl || runtimeApiBaseUrl || fallbackApiBaseUrl;
export const GOOGLE_MAPS_API_KEY = cleanApiBaseUrl(
    typeof window === 'undefined' ? '' : window.__APP_CONFIG__?.GOOGLE_MAPS_API_KEY
) || process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export function buildApiUrl(path) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${API_BASE_URL}${normalizedPath}`;
}

export function buildAuthHeaders(additionalHeaders = {}) {
    const token = localStorage.getItem('token');

    if (!token) {
        return additionalHeaders;
    }

    return {
        ...additionalHeaders,
        Authorization: `Bearer ${token}`,
    };
}
